(function () {
    'use strict';
    angular.module('app')
        .controller('JobMapOverviewController', JobMapOverviewController);

    JobMapOverviewController.$inject = [
        '$q',
        '$rootScope',
        'FleetService',
        'toastr',
        '$cookies',
        'Stomp',
        '$http'
    ];

    function JobMapOverviewController(
        $q,
        $rootScope,
        FleetService,
        toastr,
        $cookies,
        Stomp,
        $http
    ) {
        let vm = this;
        vm.activeDrivers = [];
        vm.mapData = {
            office: {
                address: "",
                officeData: ""
            },
            jobs: [],
            drivers: [],
            wayPoints: {}
        };
        vm.toggleSideBar = toggleSideBar;
        vm.showSideBar = true;

        init();

        function init() {
            vm.loadingDrivers = true;
            $q.all([getAllActiveDrivers()]).then((data) => {
                vm.mapData.office = getUserOffice();
                vm.activeDrivers = data[0];
                initializeWebSockets();
                vm.loadingDrivers = false;
            });
        }

        function toggleSideBar(){
            vm.showSideBar = !vm.showSideBar;
        }

        function getUserOffice() {
            if (!$rootScope.GlobalProfile.office.location) {
                return false;
            }

            const userOffice = $rootScope.GlobalProfile.office;
            const userOfficeLocation = $rootScope.GlobalProfile.office.location || {};
            const officeAddress = `${userOffice.addressLine1 || ''} ${userOffice.addressLine2 || ''} ${userOfficeLocation.code} ${angular.getObjVal(userOfficeLocation, 'state.name')} ${angular.getObjVal(userOfficeLocation, 'country.name')}`;

            return {
                officeData: userOffice,
                address: officeAddress
            }
        }

        function getAllActiveDrivers(filter = {}) {
            const deffered = $q.defer();
            FleetService.Drivers.getAll(data => {
                deffered.resolve(data.content);
            }, error => {
                toastr.error('Unable to load drivers', error.message);
                deffered.reject(error);
            }, {
                    size: 100,
                    sort: 'id,asc',
                    active: true
                });
            return deffered.promise;
        }
        function initializeWebSockets() {
            vm.mapData.drivers = vm.activeDrivers;
            const token = $http.defaults.headers.common.Authorization.split(' ')[1];
            const url = `${ApiURLs.webSocket.connect}?access_token=${token}`;
            const connection = new SockJS(url);
            const stompClient = Stomp.over(connection);
            
            stompClient.connect({}, frame => {
                stompClient.subscribe('/user/queue/driver/location', tick => {
                    const data = JSON.parse(tick.body);
                    vm.mapData.drivers.forEach(driver => {
                        if (driver.id == data.id) {
                            driver.latitude = data.latitude
                            driver.longhitude = data.longitude;
                            console.log('driver found');
                        }
                    });
                });
                
                stompClient.subscribe('/user/queue/driver/status', tick => {
                    const data = JSON.parse(tick.body);
                    console.log(data);
                    let existingDriver = vm.mapData.drivers.filter(driver => {
                        return driver.id == data.driverId;
                    });

                    if (existingDriver.length != 0) {
                        vm.mapData.drivers.forEach(driver => {
                            if (driver.id == data.driverId) {
                                driver.active = data.active
                            }
                        });
                    } else {
                        getDriverDetailsById(data.driverId).then(data => {
                            vm.mapData.drivers.push(data);
                        });
                    }
                });
                
                stompClient.subscribe('/user/topic/chat', tick => {
                    const data = JSON.parse(tick.body);
                    vm.newMessageData = data;
                    toastr.info(data.message, "New Message received");
                });
            }, error => {
                toastr.error('Error', 'Websocket connection failed');
            });
        }

        function getDriverDetailsById(driverId) {
            const deffered = $q.defer();
            FleetService.Drivers.get(driverId, data => {
                deffered.resolve(data);
            }, error => {
                toastr.error('Unable to load driver data', err.message);
                defer.reject(error);
            });
            return deffered.promise;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/JobMapOverviewController.js